// extracted by mini-css-extract-plugin
export var buttonContainer = "_8f-1";
export var fontSizeSelect = "_8f-3";
export var formatSelect = "_8f-2";
export var formats = "_8f-4";
export var hidden = "_8f-5";
export var icon = "_8f-6";
export var select = "_8f-0";